import React from 'react';
import AppTemp from "../AppTemp";

import {RestUrls} from "../data/Urls";

import {isMobile} from "react-device-detect";
import {getAsUriParameters, getLinkOpenTarget} from "../util/UrlUtil";

import {usePaginatedQuery} from 'react-query'
import {Avatar, Button, Card, Col, Input, List, Pagination, Row, Select, Space, Spin, Switch, Tooltip} from 'antd';
import {ClearOutlined} from '@ant-design/icons';
import {DataTypes} from "../data/Types";

import axios from "axios";
import Highlighter from "react-highlight-words";
import {CopyToClipboard} from "react-copy-to-clipboard";
// import {history} from '../_helpers';
import {useHistory, useLocation} from "react-router-dom";

// const ButtonGroup = Button.Group;

const {Search} = Input;
const {Meta} = Card;
const {Option} = Select;
// const yunHost = "https://www.yunpanjingling.com";
const typeImage = {
    "dir":
    // yunHost + "/share/images/dir.png"
        "data:image/png;base64,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"
    , "video":
    // yunHost + "https://dalipan.com/_nuxt/img/7f4be7b.png"
        "https://imgcdn.zhidahao.com/filetype/video.png"
    , "audio":
    // yunHost + "/share/images/audio.png"
        "https://imgcdn.zhidahao.com/filetype/audio.png"
    , "software":
    // yunHost + "/share/images/software.png"
        "data:image/png;base64,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"
    , "document":
    // yunHost + "/share/images/document.png"
        "data:image/png;base64,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"
    , "compress":
    // yunHost + "/share/images/compress.png"
        "data:image/png;base64,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"
    // , "ebook": yunHost + "/share/images/ebook.png"
    // , "other": yunHost + "/share/images/other.png"
};


export function Pan(props) {

    let location = useLocation();
    const history = useHistory();
    // const {pathname} = props.location;
    // let current = pathname && pathname.length > 1 && pathname.substr(1);
    let current = props.current;
    // console.log(current);
    // console.log(JSON.stringify(props))
    let hisLocation;
    if (history) {
        hisLocation = history.location;
    }
    let state = hisLocation.state ? hisLocation.state : {};
    const [time, setTime] = React.useState(state.time || '');
    const [keyword, setKeyword] = React.useState(state.keyword || '');
    const [mode, setMode] = React.useState(state.mode || '');
    const [search, setSearch] = React.useState(state.search || '');
    const [size, setSize] = React.useState(state.size || '');
    const [quality, setQuality] = React.useState(state.quality || '');
    const [sort, setSort] = React.useState(state.sort || '');
    const [page, setPage] = React.useState(state.page || 1);
    // const [source, setSource] = React.useState(state.source || 'dali');
    const [value, setValue] = React.useState(state.keyword || '');
    const [link, setLink] = React.useState(state.link || '');
    const [show, setShow] = React.useState(true);
    // let value = state.keyword || '';
    // console.log("value:" + value);

    // useEffect(() => {
    //
    // });

    function timeChange(value) {
        setTime(value);
        console.log(`selected ${value}`);
    }

    function getImage(fileType) {
        if (!fileType) return;
        let img = typeImage[fileType];
        if (!img) return;
        return <Avatar
            src={img}/>
    }


    function modeChange(value) {
        setMode(value);
        console.log(`selected ${value}`);
    }


    function filterSearchChange(value) {
        setSearch(value);
        console.log(`selected ${value}`);
    }

    function filterLinkChange(value) {
        setLink(value);
        console.log(`link selected ${value}`);
    }


    function sizeChange(value) {
        setSize(value)
    }


    function qualityChange(value) {
        setQuality(value);
        console.log(`selected ${value}`);
    }


    function resetCondition() {
        setSearch('');
        setMode('');
        setSize('');
        setTime('');
        setPage(1);
        // isDali() && setLink('');
        // if (isSpirit) {
        setQuality('');
        // isSpirit() &&
        setSort('');
        // }
    }


    function sortChange(value) {
        setSort(value);
        console.log(`selected ${value}`);
    }

    // React.useEffect(() => {
    //     if (latestData?.hasMore) {
    //         queryCache.prefetchQuery(["projects", page + 1], fetchProjects);
    //     }
    // }, [latestData, fetchProjects, page]);
    // const url = React.useState(initUrl(search, mode, size, time, quality, sort, page));

    const fetchPans = React.useCallback(async (key, {page}) => {
            if (!keyword) return {data: [], hasMore: false};
            // console.log("source:" + source)
            // let dataState = history.state;
            // console.log("dataState" + JSON.stringify(dataState));
            let dataState = {keyword, search, link, mode, size, time, quality, sort};
            let parameters = getAsUriParameters(dataState);
            // let url = parameters ? RestUrls[DataTypes.PAN_SEARCH] + "/" + source + '?' +
            //     parameters + '&page=' + page : RestUrls[DataTypes.PAN_SEARCH] + "/" + source + "?page=" + page;

            let url = parameters ? RestUrls[DataTypes.PAN_SEARCH] + '?' +
                parameters + '&page=' + page : RestUrls[DataTypes.PAN_SEARCH] + "?page=" + page;
            // let parameters = getAsUriParameters({value, search, mode, size, time, quality, sort});
            // let hostAndPath = getHostAndPath();
            // let hisData = {keyword, search, link, mode, size, time, quality, sort, source, page};
            let hisData = {keyword, search, link, mode, size, time, quality, sort, page};
            let hisParam = getAsUriParameters(hisData);
            let hostAndPath = location.pathname;
            let bar = hisParam ? hostAndPath + "?" + hisParam : hostAndPath
            // alert(bar)
            history.push(bar, hisData);
            // window.history.pushState({dataState}, "", bar);
            // window.history.pushState(dataState,"",bar);

            const {data} = await axios.get(url)
            // alert(data);
            // if (!data && 'dali' === source && page === 1) {
            //     // alert(source)
            //     setSource('spirit');
            // }


            return data;
        }, [keyword
            // , search, link, mode, size, time, quality, sort, source, history, location
            , search, link, mode, size, time, quality, sort, history, location
        ]
    );


    function getTitle(item) {
        if (!item) return null;
        let source = item.source;
        if (!source) return null;
        return '/pan/resources/' + item.id
        // let referrer = item.referrer;
        // if (referrer && referrer.indexOf("dalipan.com") !== -1) {
        //     link = "/pan/resources?url=" + referrer;
        // }
        // return link;
    }


    function getSubTitle(item) {
        let subTitle = item.subTitle ? item.subTitle : '';

        let referrer = item.referrer;
        if (subTitle) {
            // console.log("subTitle:"+JSON.stringify(subTitle));

            let copy = null;
            // if (referrer) {
            //     if (referrer.indexOf("dalipan.com") !== -1) {
            //         referrer = "/pan/resources?url=" + referrer;
            //     }
            // } else
            //     {
            let gi = subTitle.indexOf("故园怀旧");
            if (gi === -1) {
                referrer = "https://baidu.com/s?ie=utf-8&wd=" + subTitle;
                // copy = subTitle.substring(0, gi);
            } else {
                copy = item.password;
                // referrer = RestUrls[DataTypes.PAN_GYHJ] + "?keyword=" + encodeURIComponent(subTitle);
            }

            // }


            subTitle =

                <Highlighter
                    highlightClassName="keyword-highlight"
                    searchWords={[keyword]}
                    autoEscape={true}
                    textToHighlight={subTitle}
                />

            if (copy) {
                subTitle = <CopyToClipboard text={copy}
                >
                    {subTitle}
                </CopyToClipboard>
            }

            return <a href={referrer}
                      target="_blank" rel="nofollow me noopener noreferrer"
            >{subTitle}</a>;

        }
        return subTitle;
    }


    function onSearch(value) {
        if (value) {
            setPage(1);
            setKeyword(value);
            searchRef.current.blur();
        }
    }

    const searchRef = React.useRef();

    // function sourceChange(value) {
    //     console.log(value);
    //     setPage(1);
    //     // setSource(value);
    //     // resetCondition();
    //
    // }

    // function isSpirit() {
    //     return 'spirit' === source;
    // }
    //
    // function isDali() {
    //     return 'dali' === source;
    // }

    const {
        status,
        resolvedData,
        // latestData,
        error,
        isFetching,
    } = usePaginatedQuery(['pan_search', {
        page, keyword
        , search, link, mode, size, time, quality, sort
    }], fetchPans)

    function getTotal() {
        if (!resolvedData || !resolvedData.total) return 0;
        // let limit = isSpirit() ? 1000 : 300 * 30;

        let limit = 1000;
        return resolvedData.total > limit ? limit : resolvedData.total
    }

    function valueChange(e) {
        let v = e.target.value;
        setValue(v);
        // console.log(v);
    }

    function getExtra(item) {
        let time = item.updateTime;
        return time ? <span>{time}</span> : '';
    }

    // console.log("statue:"+JSON.stringify(state));
    return (
        <AppTemp current={current}>
            <div>

                <Row className="mt-2">

                    <Col span={isMobile ? 18 : 12} offset={isMobile ? 3 : 6}>
                        {/*<Space>*/}
                        <Input.Group compact>


                            <Search
                                // addonBefore={
                                //     <Select defaultValue="dali"
                                //             onSelect={sourceChange}
                                //             value={source}
                                //         // className="select-after"
                                //     >
                                //         <Option value="dali">源1</Option>
                                //         <Option value="spirit">源2</Option>
                                //     </Select>
                                // }
                                id="pan_input"
                                placeholder='关键字'
                                value={value}
                                enterButton
                                loading={isFetching}
                                onChange={valueChange}
                                size="large"
                                allowClear
                                autoFocus
                                onSearch={onSearch}
                                ref={searchRef}
                            />
                        </Input.Group>
                        {/*</Space>*/}
                    </Col>
                </Row>


                <div
                    className="container mt-2 clearfix">
                    {/*<Row >*/}
                    {/*<Col  flex="100px" className={"mt-1"}>*/}
                    <div className="float-left mt-1 me-3">
                        <Switch checkedChildren="筛选"
                                unCheckedChildren="收起"
                                defaultChecked onChange={() => setShow(!show)}/>
                    </div>
                    {/*</Col>*/}
                    {show && <div
                        // className={"float-right"}
                    >
                        <Select
                            className={'m-1'}
                            defaultValue=''
                            value={search}
                            style={{width: 120}}
                            onChange={
                                filterSearchChange}
                        >
                            <Option value="">模式</Option>
                            <Option value="all">精准搜索</Option>
                            <Option value="range">模糊搜索</Option>
                        </Select>

                        <Select
                            className={'m-1'}
                            defaultValue="-1"
                            value={link}
                            style={{width: 120}}
                            onChange={
                                filterLinkChange}
                        >
                            <Option value="">链接</Option>
                            <Option value="1">有链接</Option>
                            <Option value="0">无链接</Option>
                        </Select>


                        <Select
                            className={'m-1'}
                            defaultValue=''
                            value={mode}
                            style={{width: 120}}
                            onChange={modeChange}
                        >
                            <Option value="">类型</Option>
                            <Option value="dir">文件夹</Option>
                            <Option value="compress">压缩包</Option>
                            <Option value="software">软件</Option>
                            <Option value="video">视频</Option>
                            <Option value="audio">音频</Option>
                            <Option value="document">文档</Option>

                            <Option value="pic">图片</Option>
                            <React.Fragment>
                                <Option value="ebook">电子书</Option>
                                <Option value="other">其它</Option>
                            </React.Fragment>
                        </Select>


                        <Select
                            className={'m-1'}
                            defaultValue=''
                            value={size}
                            style={{width: 120}}
                            onChange={sizeChange}
                        >
                            <Option value="">文件大小</Option>
                            <Option value="lte_20mb">小于20MB</Option>
                            <Option value="20mb_200mb">20MB~200MB</Option>
                            <Option value="200mb_2gb">200MB~2GB</Option>
                            <Option value="gte_2gb">大于2GB</Option>
                        </Select>

                        <Select
                            className={'m-1'}
                            defaultValue=''
                            value={time}
                            style={{width: 120}}
                            onChange={timeChange}
                        >
                            <Option value="">时间</Option>
                            <Option value="latest_a_week">最近一周</Option>
                            <Option value="latest_a_month">最近一月</Option>
                            <Option value="latest_half_a_year">最近半年</Option>
                            <Option value="latest_a_year">最近一年</Option>
                        </Select>

                        {/*{isSpirit() &&*/}
                        <Select
                            className={'m-1'}
                            defaultValue=''
                            // ref={qualitySelect}
                            value={quality}
                            style={{width: 120}}
                            onChange={qualityChange}
                        >
                            <Option value="">质量</Option>
                            <Option value="BEST">优质资源</Option>

                        </Select>
                        {/*}*/}


                        <span className={"ms-2"}/>
                        {/*{isSpirit() &&*/}
                        <Select
                            className={'m-1'}
                            defaultValue=''
                            value={sort}

                            style={{width: 120}}
                            onChange={sortChange}
                        >
                            <Option value="">排序</Option>
                            <Option value="size.desc">从大到小</Option>
                            <Option value="size.asc">从小到大</Option>
                            <Option value="created_at.desc">最近收录</Option>
                        </Select>
                        {/*}*/}

                        <Button
                            // className={"float-right"}
                            className={"ms-2"}
                            type="danger" onClick={resetCondition}
                            icon={<ClearOutlined/>}/>
                    </div>}
                    {/*</Row>*/}

                </div>


                {/*{isFetching && <div*/}
                {/*    className={"ms-3"}*/}
                {/*    //       style={{marginBottom: '-40px'}}*/}
                {/*><Spin/></div>}*/}

                {
                    status === 'loading' ? (
                        ''
                        // <div
                        //     // className={"text-center"}
                        //     // style={{marginBottom: '-40px'}}
                        // ><Spin/></div>

                    ) : status === 'error' ? (
                        <div>Error: {error.message}</div>
                    ) : (isFetching && page === 1) ? '' : (

                        <div className={"mt-1"}>
                            {resolvedData.data && resolvedData.data.length > 0 &&
                            <List className="container"
                                  itemLayout="vertical"
                                  dataSource={resolvedData.data}
                                  renderItem={(item, index) => (
                                      <List.Item key={index}

                                                 extra={
                                                     getExtra(item)
                                                 }


                                                 actions={[
                                                     <Space className="mt-2">
                                                         {item.size && item.size !== 'N/A' &&
                                                         <Button>{item.size}</Button>
                                                         }
                                                         {item.status > 0 &&
                                                         <Button
                                                             type="primary" ghost>
                                                             优质资源
                                                         </Button>
                                                         }

                                                         {!item.url && item.password &&
                                                         <CopyToClipboard
                                                             text={item.password ? item.password : ''}>
                                                             <Tooltip placement="topLeft" title="提取码"
                                                                      arrowPointAtCenter>
                                                                 <Button>
                                                                     {item.password}
                                                                 </Button>
                                                             </Tooltip>
                                                         </CopyToClipboard>
                                                         }


                                                         {item.url && (item.password ?
                                                             <CopyToClipboard
                                                                 text={item.password ? item.password : ''}>
                                                                 <Tooltip placement="topLeft"
                                                                          title={item.password ? item.password : ''}
                                                                          arrowPointAtCenter>
                                                                     <Button
                                                                         type="primary"
                                                                         href={item.url}
                                                                         target="_blank"
                                                                         rel="nofollow me noopener noreferrer"
                                                                     >打开</Button>
                                                                 </Tooltip>
                                                             </CopyToClipboard> : <Button
                                                                 type="primary"
                                                                 href={item.url}
                                                                 target="_blank" rel="nofollow me noopener noreferrer"
                                                             >打开</Button>)
                                                         }

                                                         {!item.url &&
                                                         <Button href={"https://baidu.com/s?ie=utf-8&wd=" + item.title}>
                                                             百度
                                                         </Button>
                                                         }
                                                     </Space>
                                                 ]}


                                      >
                                          <Meta className={'mb-2'}


                                                avatar={
                                                    getImage(item.fileType)

                                                }
                                                title={<a
                                                    target=
                                                        {
                                                            getLinkOpenTarget()
                                                        }
                                                    href={getTitle(item)}>
                                                    <Highlighter
                                                        highlightClassName="keyword-highlight"
                                                        searchWords={[keyword]}
                                                        autoEscape={true}
                                                        textToHighlight={item.title}
                                                    />
                                                </a>}
                                                description={getSubTitle(item)}
                                          />

                                          <div>
                                              {item.fileList && item.fileList.length > 0 &&
                                              item.fileList.slice(-5).map((file, index) => (
                                                  <React.Fragment key={index}>
                                                      |-<span>
                                                   <Highlighter
                                                       highlightClassName="keyword-highlight"
                                                       searchWords={[keyword]}
                                                       autoEscape={true}
                                                       textToHighlight={file.name}
                                                   />

                                                      {file.size && <span>-
                                                                        <strong>{file.size}</strong></span>}</span><br/>
                                                  </React.Fragment>
                                              ))


                                              }
                                              {item.fileList && item.fileList.length > 5 &&
                                              <div><span>......</span></div>}
                                          </div>

                                      </List.Item>)}
                            />

                            }


                            {resolvedData && resolvedData.total && <Row
                                className={`container text-center ${isMobile ? 'mb-2 pb-2' : ''}`}>

                                <Col span={22}>
                                    <Pagination
                                        defaultCurrent={1}
                                        current={page}
                                        total={getTotal()}
                                        pageSize={30}
                                        showSizeChanger={false}
                                        simple={isMobile}
                                        showTotal={total => `总共 ${total} 条记录`}
                                        // showQuickJumper = {true}
                                        onChange={function (page) {
                                            setPage(page);
                                        }}

                                    />
                                </Col>
                                {isFetching && <Col span={1}><Spin/></Col>}
                            </Row>
                            }
                        </div>)
                }


            </div>

        </AppTemp>)


}

